class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.addVehicleButtons = document.querySelectorAll('.find-vehicle__button');
    this.selectedVehicle = JSON.parse(localStorage.getItem('partbot_selected_vehicle'))?.description;

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    if (this.selectedVehicle) {
      this.setSelectedVehicle(this.selectedVehicle);
    }

    this.addVehicleButtons.forEach((button) => {
      button.classList.add('loaded');
    });

    document.addEventListener('vehicle-search-change', (e) => {

      const vehicle = e.detail.vehicle?.description;
      this.setSelectedVehicle(vehicle);

      // Pages that react to the vehicle in place (the kit builder) opt out of
      // the jump to all products with data-stay-on-vehicle-change.
      if (document.querySelector('[data-stay-on-vehicle-change]')) return;

      setTimeout(() => {
        window.location.replace(`/collections/all/${window.location.search}`);
      }, 100);
    });

    document.addEventListener("vehicle-search-submit", (e) => {

    });

    document.addEventListener('partbot-clear-vehicle', () => {

      this.clearSelectedVehicle();
    });

    // Picking a vehicle from the PartBot garage (or by rego) fires
    // vehicle-garage-change / plate-search-change, not vehicle-search-change,
    // so the button kept saying "Add Vehicle" until a reload while the hero
    // button had already updated. Re-read the saved vehicle on every PartBot
    // change event (window and document, like the hero), on storage changes
    // from other tabs, and when the page comes back from the back/forward cache.
    const sync = () => setTimeout(() => this.syncFromStorage(), 0);
    ['vehicle-garage-change', 'vehicle-search-change', 'plate-search-change', 'partbot-clear-vehicle'].forEach((name) => {
      window.addEventListener(name, sync);
      document.addEventListener(name, sync);
    });
    window.addEventListener('storage', (e) => {
      if (e.key === 'partbot_selected_vehicle') sync();
    });
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) sync();
    });
  }

  syncFromStorage() {
    let vehicle = null;
    try {
      vehicle = JSON.parse(localStorage.getItem('partbot_selected_vehicle'))?.description;
    } catch (e) {}
    if (vehicle) this.setSelectedVehicle(vehicle);
    else this.clearSelectedVehicle();
  }

  setSelectedVehicle(vehicle) {
    this.addVehicleButtons.forEach((button) => {
      button.classList.add('selected-vehicle');
      button.querySelector('.text-wrapper').textContent = vehicle;
    });
  }

  clearSelectedVehicle() {

    this.addVehicleButtons.forEach((button) => {
      button.classList.remove('selected-vehicle');
      // Each button's own label: the desktop one reads "ADD MY VEHICLE", the
      // phone one "Add Vehicle" (no room for more).
      button.querySelector('.text-wrapper').textContent = button.getAttribute('aria-label');
    });
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
